<script lang="ts" setup>
import { useToast } from 'vue-toastification';
import ToastComponent from '~/components/ui/ToastComponent.vue';
import { makeOfferShareUrl, makeSocialShareUrl } from '~/utils/shareOfferUrl';

const { selectedOffer, selectedSizeId } = storeToRefs(useCatalogStore());
const { appUrl } = useRuntimeConfig().public;
const isShowModal = ref(false);
const { sendShareOfferEventToDataLayer } = useGtmModule();
const shareUrl = computed(() => {
  const selectedOfferId = selectedSizeId.value ?? selectedOffer.value.selected_offer_id;

  return makeOfferShareUrl(appUrl, selectedOffer.value.uri, selectedOfferId);
});

function copyLink() {
  if (!isSupported.value) return;

  copy(shareUrl.value);
  if (selectedOffer.value) sendShareOfferEventToDataLayer(selectedOffer.value, 'link');
  isShowModal.value = false;
}

function shareByVk() {
  window.open(makeSocialShareUrl('https://vk.ru/share.php', shareUrl.value), '_blank');
  if (selectedOffer.value) sendShareOfferEventToDataLayer(selectedOffer.value, 'VK');
  isShowModal.value = false;
}

function shareByTg() {
  window.open(makeSocialShareUrl('https://t.me/share/url', shareUrl.value), '_blank');
  if (selectedOffer.value) sendShareOfferEventToDataLayer(selectedOffer.value, 'TG');
  isShowModal.value = false;
}

const { text, copy, copied, isSupported } = useClipboard();
const toast = useToast();

watch(
  () => copied.value,
  () => {
    if (copied.value)
      toast.info(
        { component: ToastComponent, props: { text: 'Скопировано: ' + text.value } },
        {
          timeout: 2000,
          hideProgressBar: true,
          icon: false,
        },
      );
  },
);
</script>

<template>
  <button @click="isShowModal = true">
    <SvgoShare
      :font-controlled="false"
      class="share-button"
      filled
    />

    <BaseModal
      v-model="isShowModal"
      @close="isShowModal = false"
    >
      <div class="share-modal">
        <button
          class="share-modal__item"
          @click="copyLink"
        >
          <SvgoCopy
            :font-controlled="false"
            class="size-6"
            filled
          />

          Скопировать ссылку
        </button>

        <button
          class="share-modal__item"
          @click="shareByVk"
        >
          <SvgoSocialVk
            :font-controlled="false"
            class="size-6"
            filled
          />

          Вконтакте
        </button>

        <button
          class="share-modal__item"
          @click="shareByTg"
        >
          <SvgoSocialTelegram
            :font-controlled="false"
            class="size-6"
            filled
          />

          Telegram
        </button>
      </div>
    </BaseModal>
  </button>
</template>

<style lang="scss" scoped>
.share-button {
  width: 24px;
  height: 24px;
  color: $black-40;
  transition: all 0.3s ease;

  &:hover {
    color: $black-20;
  }
}

.share-modal {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: $bold;
  font-size: $text-sm;

  @include screen-sm {
    min-width: 300px;
  }

  &__item {
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid $black-20;
    color: $black;
    transition: color 0.3s ease;

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }

    &:hover {
      color: $label-violet;
    }
  }
}
</style>
